import React from 'react';
export function ProofBar() {
  return <div className="bg-gradient-to-br from-card-bg to-[rgba(107,0,182,0.3)] border-y border-[rgba(194,0,111,0.3)] py-3 md:py-4 px-5" data-id="element-244" data-mp="1r30i1c2q3qdy">
      <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5 text-center" data-id="element-245" data-mp="7l2cnj87ld8p">
        <div className="flex flex-col items-center" data-id="element-246" data-mp="cjvtnlmpfmdm">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-247" data-mp="cikl78ibdqg6">
            40%
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-248" data-mp="3j7a6bejkttc">
            Anxiety reduction, based on cognitive neuroscience protocols
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-249" data-mp="3ktf9v3wixzys">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-250" data-mp="3ppvw1sk5y498">
            4 Vol.
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-251" data-mp="1iy4ra8qqzsq8">
            The complete collection — The Path to Recovery
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-252" data-mp="2se6rghb3y48l">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-253" data-mp="2scvq0o54x8kn">
            21 days
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-254" data-mp="323q9jkqzxu2e">
            Daily practices of a few minutes to reprogram the cycle
          </p>
        </div>
      </div>
    </div>;
}